module.exports = "<mat-card class=\"login-card\">\n    <mat-card-content class=\"login-card-body\">\n      <div fxLayout=\"column\" fxLayoutAlign=\"start stretch\">\n          <mat-input-container>\n            <input matInput type=\"text\" placeholder=\"Key\" [(ngModel)]=\"key\" trim />\n          </mat-input-container>\n      </div>\n    </mat-card-content>\n    <mat-card-actions class=\"login-card-actions\">\n      <button mat-raised-button class=\"login-button\" (click)=\"login()\">Log In</button>\n    </mat-card-actions>\n  </mat-card>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/login/login.html
// module id = ./src/app/components/login/login.html
// module chunks = main